import { Input } from '@progress/kendo-react-inputs';
import CustomButton from '../../../../components/stateless/customButton/CustomButton';
import { useOfficialManagementController } from './OfficialManagementController';

function OfficialManagement() {
  const {
    toggleEditAG,
    toggleEditGov,
    toggleEditSos,
    handleGovNameChange,
    handleAGNameChange,
    handleSosNameChange,
    agNameObj,
    govNameObj,
    sosNameObj,
    editAG,
    editGov,
    editSos
  } = useOfficialManagementController();

  return (
    <div>
      <div>
        {!editGov && (
          <div>
            {govNameObj?.fieldValue}
            <CustomButton onClick={toggleEditGov}>
              Update Governor Name
            </CustomButton>
          </div>
        )}
        {editGov && (
          <div>
            <Input type='text' defaultValue={govNameObj?.fieldValue} onChange={handleGovNameChange}/>
            <CustomButton onClick={toggleEditGov}>
              Save
            </CustomButton>
          </div>
        )}
      </div>

      <div>
        {!editAG && (
          <div>
          {agNameObj?.fieldValue}
          <CustomButton onClick={toggleEditAG}>
            Update AG Name
          </CustomButton>
        </div>
        )}

        {editAG && (
          <div>
            <Input type='text' defaultValue={agNameObj?.fieldValue} onChange={handleAGNameChange}/>
            <CustomButton onClick={toggleEditAG}>
              Save
            </CustomButton>
          </div>
        )}
      </div>

      <div>
        {!editSos  && (
          <div>
          {sosNameObj?.fieldValue}
          <CustomButton onClick={toggleEditSos}>
            Update SOS Name
          </CustomButton>
        </div>
        )}
        {editSos && (
          <div>
            <Input type='text' defaultValue={sosNameObj?.fieldValue} onChange={handleSosNameChange}/>
            <CustomButton onClick={toggleEditSos}>
              Save
            </CustomButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default OfficialManagement;